<div class="max-h-full container my-6 rounded-2xl flex relative overflow-hidden w-full bg-white">


  <swiper-container class="mySwiper lg:h-[500px] 2xl:h-[550px]  aspect-[4/1.5] sm:aspect-[4/2] lg:aspect-auto"
    pagination="true" pagination-clickable="true" navigation="true" space-between="30" centered-slides="true"
    autoplay-delay="4000" autoplay-duration="1000" loop="true" autoplay-disable-on-interaction="false">

    <swiper-slide class="swiper-slide " (click)="onClickService()">
      <img class="w-full h-full" src="/assets/banner/01.webp" alt="banner" />
    </swiper-slide>
    <swiper-slide class="swiper-slide">
      <img class="w-full h-full" src="/assets/banner/02.webp" alt="banner" />
    </swiper-slide>
    <swiper-slide class="swiper-slide ">
      <img class="w-full h-full" src="/assets/banner/03.webp" alt="banner" />
    </swiper-slide>
    <div class="autoplay-progress" slot="container-end">
      <svg viewBox="0 0 48 48">
        <circle cx="24" cy="24" r="20"></circle>
      </svg>
      <span></span>
    </div>
  </swiper-container>
</div>